module.exports = __webpack_public_path__ + "img/table-icon-teams.f15e3bbd.png";